import React, { useState } from 'react';
import { Grid, makeStyles, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Theme from '../ui/Theme';
import ErrorIcon from '../../assets/ErrorIcon';
import Modal from '../common/Modal';

const useStyles = makeStyles(() => ({
  deleteBtn: {
    width: '261px',
    height: '42px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  cancelBtn: {
    width: '166px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  title: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    color: '#10182B',
    marginTop: '10px',
  },
  subTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#667085',
    marginTop: '5px',
  },
}));

const DeleteConfirmationRule = (props) => {
  const classes = useStyles();

  const [viewConfirm, setViewConfirm] = useState(props.open);

  const closePopup = () => {
    setViewConfirm(false);
    props.close();
  };
  const deleteFn = () => {
    closePopup();
    props.delFn();
  };

  return (
    <Modal isOpen={viewConfirm} height="258px" width="475px">
      <Grid container direction="column">
        <Grid item>
          <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
            <Grid item xs={11}></Grid>
            <Grid item xs={1}>
              <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
            </Grid>
          </Grid>
        </Grid>

        <Grid container direction="column" justifyContent="center" alignContent="center">
          <Grid item style={{ textAlign: 'center' }}>
            <ErrorIcon style={{ height: '75px' }} />
          </Grid>
          <Grid item>
            <div className={classes.title}> Are you sure you want to delete this rule?</div>
          </Grid>
          <Grid item>
            <div className={classes.subTitle}>
              This rule is mapped to {props.journeyCount || 0} journeys. You can’t undo this action.
            </div>
          </Grid>
        </Grid>

        <Grid container direction="column" justifyContent="center" alignContent="center">
          <Grid item style={{ marginTop: '40px' }}>
            <Button variant="contained" disableElevation className={classes.cancelBtn} onClick={closePopup}>
              Don’t Delete
            </Button>
            <Button variant="contained" className={classes.deleteBtn} onClick={deleteFn}>
              <div style={{ color: '#EB5757' }}>I’m sure! Delete this</div>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default DeleteConfirmationRule;
